export const tabs = [
  {
    id: 1,
    label: 'Activities',
    path: '/activities'
  },
  {
    id: 2,
    label: 'Training Type',
    path: '/training-type'
  }
]

export const tableHeaders = [
  {
    id: 3,
    label: 'Category'
  },
  {
    id: 4,
    label: 'Section'
  },
  {
    id: 5,
    label: 'Participants'
  }
]
